import React from "react";
import "./help.css";
import { AccordionSummary, styled } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: "8px",
  borderRadius: "8px !important",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1) !important",
  "&:before": {
    display: "none",
  },
  "&.Mui-expanded": {
    margin: "8px 0",
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: "#f5f5f5",
  borderRadius: "8px",
  "&:hover": {
    backgroundColor: "#e0e0e0",
  },
  "&.Mui-expanded": {
    minHeight: "48px",
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: "16px",
  backgroundColor: "#ffffff",
  borderRadius: "0 0 8px 8px",
}));

const helpItems = [
  {
    helpTitle: "1:Yarışma kaç aşamadan oluşuyor?",
    helpText:
      "Yarışma 4 aşamadan oluşuyor. Birinci Aşama Sınavı,İkinci Aşama GriCeviz Oyunları, Üçüncü Aşama Sınavı ve Dördüncü Aşama Final Sınavı. ",
  },
  {
    helpTitle: "2: Yarışma nerede olacak?",
    helpText:
      "Yarışmanın Birinci Aşama ve Üçüncü Aşama Sınavları oyun.tzv.org.tr web sayfası üzerinden çevrimiçi olarak,İkinci Aşama Sınavı GriCeviz Bilişsel Beceri ve Zihinsel Gelişim Platformu'u üzerinden, Final Sınavı Ankara'da yazılı olarak yapılacaktır.",
  },

  {
    helpTitle: "3: Yarışma kaç kategoride yapılıyor?",
    helpText: (
      <ul className="list-items">
        <li>
          <strong>MİNİKLER</strong> 6-7-8 yaş (2019, 2018 ve 2017 yıllarında
          doğanlar. Okuma, yazma ve matematikte dört işlem becerisine sahip
          olmak gereklidir.)
        </li>
        <li>
          <strong>ÇOCUKLAR</strong> 9-10-11-12-13 yaş (2016, 2015, 2014, 2013,
          2012 yıllarında doğanlar.)
        </li>
        <li>
          <strong>GENÇLER</strong> 14-15-16-17-18 yaş (2011, 2010, 2009, 2008,
          2007 yıllarında doğanlar.)
        </li>
        <li>
          <strong>YETİŞKİNLER</strong> 19-49 yaş arası (2006, … , 1976
          yıllarında doğanlar.)
        </li>
        <li>
          <strong>EMEKTARLAR</strong> 50 yaş ve üstü (1975 ve önceki yıllarda
          doğanlar.)
        </li>
      </ul>
    ),
  },
  {
    helpTitle: "4: Yarışmaya kimler katılabilir?",
    helpText:
      "Yarışmaya dileyen herkes katılabilir. MİNİKLER kategorisinde okuma, yazma ve matematikte dört işlem becerisine sahip olmak gereklidir.",
  },
  {
    helpTitle: "5: Yarışmaya nasıl kayıt olabilirim?",
    helpText:
      "Yarışmaya kayıt olmak için oyun.tzv.org.tr adresine giderek 'Kaydol' butonuna tıklayıp kayıt olabilirsiniz.",
  },
  {
    helpTitle: "6: Yarışma ücretli midir?",
    helpText:
      "Yarışmaya kayıt ücreti 300 TL'dir. Bu ücret Birinci Aşama Sınavı'na girişte ödenir; bunun dışında başka bir ödeme yoktur.",
  },

  {
    helpTitle: "7: Yarışma ücretini nasıl yatıracağım?",
    helpText:
      "Yarışma sayfasına kayıt olduktan sonra kredi kartı veya banka kartı ile işlemi gerçekleştirebilirsiniz. Kredi/banka kartı ile ödeme yapabilmeniz için kartınızın internetten alışverişe (mail-order) açık olması gerekmektedir. Aldığınız hatalar için öncelikle bankanızla iletişime geçmelisiniz.",
  },
  {
    helpTitle: "8: Sınav sonunda cevaplar yayınlanacak mı?",
    helpText:
      "Cevaplar yayınlanır, yarışmacılar kontrollerini ve varsa itirazlarını yapabilirler Soruların çözümleri yayınlanmaz.",
  },
  {
    helpTitle:
      "9: Yarışmaya katılan ancak herhangi bir sebeple cevapları giremeyen kişiler için telafi sınavı yapılacak mı?",
    helpText:
      "Hayır. Yarışma tüm yarışmacılar için aynı gün ve saatte başlayacak ve bitecektir. Cevaplarını girmemiş yarışmacılar için bir telafi söz konusu değildir.",
  },
  {
    helpTitle:
      "10: Bir e-postayla birden fazla kişinin kayıt işlemini sağlayabilir miyim?",
    helpText:
      "Hayır. Her bir katılımcı için ayrı bir e-posta adresi gereklidir.",
  },
  {
    helpTitle: "11: Okul veya kurum olarak katılım sağlanabilir mi?",
    helpText:
      "Okul ya da kurum olarak toplu kayıt sağlamak için info@tzv.org.tr üzerinden iletişime geçebilirsiniz.",
  },
  {
    helpTitle: "12: Yarışmada alacağım belgelere nasıl ulaşabilirim?",
    helpText:
      "Yarışma sonunda, ödül kriterlerinde belirtilen belgeler yarışmacılara verilecektir. Belgeleriniz hazır olduğunda, profil sayfanızda yer alan 'Belgelerim' butonuna tıklayarak belgelerinizi görüntüleyebilir ve indirebilirsiniz.",
  },
  {
    helpTitle: "13: Geçmiş yıllara ait belgelere nasıl ulaşabilirim?",
    helpText:
      "Yarışmacılara sunulan PDF belgeler, yalnızca bir sonraki yarışma sezonu başlayana kadar sistemde tutulur. Yeni sezonun başlamasıyla birlikte belgeler sistemden silinir. Bu nedenle, yarışmacıların belgelerini kendi cihazlarına indirerek saklamaları önemle tavsiye edilir.",
  },
];

export default function Help() {
  return (
    <div className="helpPage">
      <h2 className="faq">Sık Sorulan Sorular</h2>
      {helpItems.map((i) => {
        return (
          <StyledAccordion key={i.helpTitle}>
            <StyledAccordionSummary className="accordionEdit">
              {i.helpTitle}
            </StyledAccordionSummary>
            <StyledAccordionDetails>{i.helpText}</StyledAccordionDetails>
          </StyledAccordion>
        );
      })}
      <div className="editContent">
        <h2>İletişim Bilgilerimiz</h2>
      </div>
      <p style={{ textAlign: "left" }}>
        Her türlü sorun, öneri ve şikayetleriniz için bize ulaşabilirsiniz.
      </p>
      <h4
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          color: "#333",
          textAlign: "left",
          marginLeft: 0,
        }}
      >
        <LocationOnIcon />
        ADRES
      </h4>
      <p style={{ color: "#666", lineHeight: "1.6", textAlign: "left" }}>
        ODTÜ-Halıcı Yazılımevi <br />
        İnönü Bulvarı 06531 <br />
        ODTÜ-Teknokent / ANKARA
      </p>
      <h4
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          color: "#333",
          textAlign: "left",
          marginLeft: 0,
        }}
      >
        <EmailIcon />
        E-POSTA
      </h4>
      <a
        href="mailto:info@tzv.org.tr?Subject:Oyun"
        className="editContent"
        style={{
          textDecoration: "none",
          color: " #582b71",
          fontWeight: "bold",
          textAlign: "left",
          display: "block",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        info@tzv.org.tr
      </a>
    </div>
  );
}
